import fetch from '@/utils/fetch';

// 获取当前产品信息
export function getProductList(params = {}) {
  const page = Math.ceil(params.offset / params.limit) + 1
  params.page = page
  return fetch({
    url: '/shop/v1/goods',
    method: 'get',
    params: params
  })
}

// 获取商品详情
export function getProduct(id) {
  return fetch({
    url: '/shop/v1/goods/' + id,
    method: 'get'
  })
}

export function createProduct(data) {
  return fetch({
    url: '/shop/v1/goods',
    method: 'post',
    data: data
  })
}

export function updateProduct(id, data) {
  return fetch({
    url: '/shop/v1/goods/' + id,
    method: 'put',
    data: data
  })
}

// 更新库存
export function updateStocks(id, data) {
  return fetch({
    url: `/shop/v1/goods/${id}/stock`,
    method: 'post',
    data: { skus: data}
  })
}

// 获取所有分类
export function getCategories() {
  return fetch({
    url: '/api/v1/categories?limit=38',
    method: 'get'
  })
}

// 获取品牌列表
export function getBrandList(params) {
  return fetch({
    url: '/api/v1/brands',
    method: 'get',
    params
  })
}
